import { Injectable } from '@angular/core';
import { HttpService } from '../app/utility/http-service';

export interface DataModelSchemaField {
  fieldName: string;
  displayName: string;
  fieldType: string;
  unitId?: string;
  unitName?: string;
  unitSetName?: string;
}

export interface DataModelSchemaTable {
  schemaName: string;
  tableName: string;
  displayName: string;
  fields: DataModelSchemaField[];
}


export type ChildAggregate = 'None' | 'First' | 'Max' | 'Min' | 'Avg' | 'Sum';

export interface LinkConversionMapping {
  LinkSchema?: string;
  LinkTable: string;
  LinkAlias?: string;
  Then?: LinkConversionMapping;
}

export interface FieldReplace {
  Replace: string;
  With: string;
}

export interface CumulativeOptions {
  SequenceField: string;
  ParentSchema?: string;
  ParentTable: string;
  ParentLinkAlias?: string;
}

export interface SequenceMapping {
  ParitionFields: string[];
  OrderByFields: string[];
  Ascending: boolean;
}

export interface FieldConversionMapping {
  IsFunction: boolean;
  IsConstant: boolean;

  FromField?: string;
  ToField?: string;

  Suffix?: string;
  Prefix?: string;

  LinkSchema?: string;
  LinkTable?: string;
  LinkAlias?: string;
  Link?: LinkConversionMapping;

  BlindJoin?: boolean;

  ChildSchema?: string;
  ChildTable?: string;
  ChildAlias?: string;
  ChildAggregate?: ChildAggregate;

  MaxChars?: number;
  IsFraction?: boolean;
  IgnoreUnits?: boolean;
  Inverse?: boolean;

  Divide?: number;
  Multiply?: number;

  SourceUnitSet?: string;
  SourceUnit?: string;

  CumulativeOrder?: CumulativeOptions;
  Addition?: FieldConversionMapping[];
  ReportStartHour?: number;

  Concatenate?: FieldConversionMapping[];
  ConcatenateDelimiter?: string;

  Switches?: SwitchConversionMapping[];
  SwitchDefault?: string;

  FunctionFields?: FieldConversionMapping[];

  FormatString?: string;
  ExpectedResult?: string;
  CastType?: string;

  DefaultValue?: string;
  Replace?: FieldReplace[];

  IsTime?: boolean;
  SequenceMapping?: SequenceMapping;
}

export interface SwitchConversionMapping {
  FromCondition?: ConditionMapping;
  From?: FieldConversionMapping;
  FromField?: string;
  ValueCondition: string;
  ValueResult: string;
  IsConstant: boolean;
}

export interface ConditionMapping {
  Type: string;
  Left?: string;
  Right?: string;
  LeftField?: FieldConversionMapping;
  RightField?: FieldConversionMapping;
  IsConstant?: boolean;
  ChildConditions?: ConditionMapping[];
}

export interface TableConversionMapping {
  FromSchema?: string;
  FromTable: string;
  ToSchema: string;
  ToTable: string;
  Condition?: ConditionMapping;
  Distinct: boolean;
  FieldConversions: FieldConversionMapping[];
  GroupBy: FieldConversionMapping[];
}

@Injectable({
  providedIn: 'root'
})
export class ClientPayloadService {
  private readonly basePath = 'ClientSettings';

  constructor(private http: HttpService) { }

  getDataModelSchema(
    schemaName: string,
    onSuccess: (tables: DataModelSchemaTable[]) => void,
    onError?: (err: any) => void
  ): void {
    const uri = `${this.basePath}/GetDataModelSchema?schemaName=${schemaName}`;
    this.http.get<DataModelSchemaTable[]>(uri, onSuccess, true);
  }

  getMappingPayload(
    dataSetId: string,
    onSuccess: (raw: string | null) => void,
    onError?: (err: any) => void
  ): void {
    const uri = `${this.basePath}/GetMappingPayload?dataSetId=${dataSetId}`;
    this.http.get<string | null>(uri, onSuccess, true);
  }

  saveMappingPayload(
    dataSetId: string,
    payload: string | null,
    onSuccess: () => void,
    onError?: () => void
  ): void {
    const body = { dataSetId, payload };
    this.http.postReturn(
      `${this.basePath}/SaveMappingPayload`,
      onSuccess,
      undefined,
      body,
      onError
    );
  }
}
